export function check(taskid, callback){
	$.ajax({
		url: "../php/check.php",
		method: "post",
		data:"input="+taskid,
		success: function(r1,r2,r3){
			console.log("Check begin");
			callback();
		},
		error: function(r1){
			console.error("Check failed: "+r1);
		}
	});
}

export function check2(jobid, uid, callback){
	$.ajax({
		url: "../php/check2.php",
		method: "post",
		data:"jobid="+jobid+"&uid="+uid,
		//timeout:100000,
		success: function(r1,r2,r3){
			console.log("Check begin"+r1);
			callback();
		},
		error: function(r1){
			console.error("Check failed: "+r1);
		}
	});
}
